module.exports = __webpack_public_path__ + "assets/img/3.cb8b9d7b.jpg";